import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';

import { SideNavOuterToolbarModule, SideNavInnerToolbarModule, SingleCardModule } from './layouts';
import { FooterModule, LoginFormModule } from './shared/components';
import { AuthService, ScreenService, AppInfoService } from './shared/services';
import { AppRoutingModule } from './app-routing.module';
import { CookieService} from 'ngx-cookie-service';
import { HomeComponent } from './pages/home/home.component';
import { WorksheetComponent } from './pages/worksheet/worksheet.component';
import { FormItemControlService } from '../app/services/form-item-control.service';
import { DynamicFormComponent } from './pages/dynamic-form/dynamic-form.component';
import { DynamicFormItemComponent } from './pages/dynamic-form-item/dynamic-form-item.component';

import {
  DxSelectBoxModule,
  DxTextAreaModule,
  DxDateBoxModule,
  DxFormModule,
  DxNumberBoxModule,
  DxDropDownBoxModule,
  DxDropDownButtonModule,
  DxListModule,
  DxBoxModule,
  DxTabsModule,
  DxTextBoxModule,
  DxValidationGroupModule,
  DxScrollViewModule,
  DxCheckBoxModule,
  DxButtonModule,
  DxToolbarModule,
  DxTemplateModule,
  DxPopupModule,
  DxLoadPanelModule,
  DxValidatorModule,
  DxTileViewModule,
} from 'devextreme-angular';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    WorksheetComponent,
    DynamicFormComponent,
    DynamicFormItemComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    SideNavOuterToolbarModule,
    SideNavInnerToolbarModule,
    SingleCardModule,
    FooterModule,
    LoginFormModule,
    AppRoutingModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxDateBoxModule,
    DxFormModule,
    DxTabsModule,
    DxNumberBoxModule,
    DxDropDownBoxModule,
    DxDropDownButtonModule,
    DxListModule,
    DxBoxModule,
    DxScrollViewModule,
    DxCheckBoxModule,
    DxButtonModule,
    DxToolbarModule,
    DxTemplateModule,
    DxPopupModule,
    DxLoadPanelModule,
    DxTextBoxModule,
    DxValidationGroupModule,
    DxValidatorModule,
    DxTileViewModule
  ],
  providers: [AuthService, ScreenService, AppInfoService, FormItemControlService, CookieService],
  bootstrap: [AppComponent]
})
export class AppModule { }
